export const DATAURI_DEATH_WHITE =
	`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16'%3E%3Cg fill='white'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16'/%3E%3Cpath d='M8 4a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v4a.5.5 0 0 1-1 0v-4h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 8 4'/%3E%3C/g%3E%3C/svg%3E`.replace(
		/\s/g,
		'%20',
	)
